import { OnInit, Component, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute, RouterOutlet } from '@angular/router';
import { HelpLinkService } from '@core/services/help-link.service';
import { LoaderComponent } from '@app/shared/components/ui';
import { LoaderService } from '@core/services/loader.service';
import { MixpanelService } from '@app/core/infrastructure/analytics';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private readonly mixpanel = inject(MixpanelService);
  private readonly router = inject(Router);
  readonly activeRoute = inject(ActivatedRoute);
  private readonly productIdService = inject(HelpLinkService);
  private readonly loaderService = inject(LoaderService);
  readonly isSpinnerVisible = this.loaderService.isLoading;
  mainUrl: string;

  constructor() {
    this.mixpanel.init();
  }

  ngOnInit() {
    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationStart) {
          this.loaderService.show();
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.loaderService.hide();
        }
      },
      error: () => {
        this.loaderService.hide();
      }
    });

    this.productIdService.setHelpLink();
  }
}
